export enum ConsultType {
    opLocatie = 'Op locatie',
    telefonisch = 'Telefonisch',
    video = 'Video',
}
